import { QuestionnaireConditionContext } from 'utils/adl-services';

export const QUOTA_LOGIC_MIN_VALUE = 0;
export const QUOTA_LOGIC_DEFAULT_VALUE = 1;
export const CONDITION_CONTEXTS_SUPPORT_QUOTA = [
  QuestionnaireConditionContext.Answer,
  QuestionnaireConditionContext.Visibility,
  QuestionnaireConditionContext.Taxonomy,
  QuestionnaireConditionContext.Concept,
  QuestionnaireConditionContext.Variable,
];
